import { call, put, takeLatest } from 'redux-saga/effects';
import { authApi } from '../../../services/authApi';
import { AuthUser } from '../../../helpers/types';
import { clearAuthToken, getAuthToken } from '../../../helpers/request';
import { portalActions as actions } from '.';

function* handleBootstrap() {
  if (!getAuthToken()) {
    yield put(actions.sessionCleared());
    return;
  }
  try {
    const user = (yield call(authApi.me)) as AuthUser;
    yield put(actions.sessionEstablished(user));
  } catch {
    clearAuthToken();
    yield put(actions.sessionCleared());
  }
}

function* handleLogout() {
  yield call(clearAuthToken);
}

export function* portalSaga() {
  yield takeLatest(actions.bootstrapRequest.type, handleBootstrap);
  yield takeLatest(actions.logout.type, handleLogout);
}
